export class HrSurvey {
    id!: string
    name!: string
    displayOrder!: number
    numberSent!: number
    numberCompleted!: number
    numberOfFollowUps!: number
    numberOfTrainings!: number
}
